import { jsxs as a, Fragment as c, jsx as d } from "react/jsx-runtime";
import * as u from "react";
import { TAB as l } from "./utils/key-codes.js";
const e = "mistica-tab-navigation", m = `
    body:not(.${e}) *:focus,
    body:not(.${e}) *:active {
        outline: none;
        -webkit-tap-highlight-color: transparent;
    }
`;
let t = !1;
const f = (param)=>{
    let { children: i , disabled: o  } = param;
    return u.useEffect(()=>{
        if (o) return;
        if (t) {
            process.env.NODE_ENV !== "production" && console.warn("Multiple TabFocus instances");
            return;
        }
        t = !0;
        const n = (r)=>{
            r.key === "Tab" || r.keyCode === l ? document.body.classList.add(e) : document.body.classList.remove(e);
        }, s = ()=>{
            document.body.classList.remove(e);
        };
        return window.addEventListener("keydown", n), window.addEventListener("mouseup", s), ()=>{
            t = !1, window.removeEventListener("keydown", n), window.removeEventListener("mouseup", s);
        };
    }, [
        o
    ]), /* @__PURE__ */ a(c, {
        children: [
            !o && /* @__PURE__ */ d("style", {
                children: m
            }),
            i
        ]
    });
}, p = f;
export { p as default };
